import script from "./AssetMaterialPropertiesForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetMaterialPropertiesForm.vue?vue&type=script&setup=true&lang=ts"

import "./AssetMaterialPropertiesForm.vue?vue&type=style&index=0&id=106a8418&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106a8418"]])

export default __exports__